import { render, staticRenderFns } from "./ContentWithMedia.vue?vue&type=template&id=13e844cc&scoped=true&"
import script from "./ContentWithMedia.vue?vue&type=script&lang=ts&"
export * from "./ContentWithMedia.vue?vue&type=script&lang=ts&"
import style0 from "./ContentWithMedia.vue?vue&type=style&index=0&id=13e844cc&lang=scss&scoped=true&"
import style1 from "./ContentWithMedia.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13e844cc",
  null
  
)

export default component.exports